import * as React from 'react';
import { SVGProps } from 'react';
const ZoomIn = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 122.88 122.76"
		{...props}
	>
		<path d="M114.89 89.82c0-2.21 1.79-4 4-4s4 1.79 4 4v28.75c0 2.21-1.79 4-4 4H89.67c-2.21 0-4-1.79-4-4s1.79-4 4-4h19.18L74.49 82.09a3.994 3.994 0 0 1-.17-5.64 3.994 3.994 0 0 1 5.64-.17l34.93 33.02V89.82zM89.82 7.99c-2.21 0-4-1.79-4-4s1.79-4 4-4h28.75c2.21 0 4 1.79 4 4V33.2c0 2.21-1.79 4-4 4s-4-1.79-4-4V14.03L82.09 48.39a3.994 3.994 0 0 1-5.64.17 3.994 3.994 0 0 1-.17-5.64L109.3 7.99H89.82zM7.99 32.76c0 2.21-1.79 4-4 4s-4-1.79-4-4V4.01c0-2.21 1.79-4 4-4H33.2c2.21 0 4 1.79 4 4s-1.79 4-4 4H14.03l34.36 32.48c1.6 1.51 1.68 4.03.17 5.64a3.994 3.994 0 0 1-5.64.17L7.99 13.28v19.48zm24.95 82.01c2.21 0 4 1.79 4 4s-1.79 4-4 4H4.19c-2.21 0-4-1.79-4-4V89.55c0-2.21 1.79-4 4-4s4 1.79 4 4v19.18l32.48-34.36a3.994 3.994 0 0 1 5.64-.17c1.6 1.51 1.68 4.03.17 5.64l-33.02 34.93h19.48z" />
	</svg>
);
export default ZoomIn;
